import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export function scoreLevel(score) {
  if (score >= 80) return { color: "#10B981", label: "Excellente conformité", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" };
  if (score >= 60) return { color: "#F59E0B", label: "Conformité moyenne", badge: "bg-amber-50 text-amber-700 border-amber-200" };
  return { color: "#EF4444", label: "Profil atypique", badge: "bg-rose-50 text-rose-700 border-rose-200" };
}

export const ConformityGauge = ({ score, size = 96, stroke = 9, testId }) => {
  const [animated, setAnimated] = useState(0);
  const level = scoreLevel(score);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 900;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setAnimated(Math.round(score * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testId} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={level.color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c - (c * score) / 100 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="text-2xl font-black font-mono" style={{ color: level.color }}>{animated}%</span>
      </div>
    </div>
  );
};
